import styled from 'styled-components';

const ActionsContainer = styled.div`
  display: flex;
  justify-content: space-around;
`;

const Row = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-bottom: 25px;
`;

export { ActionsContainer, Row };
